import { render, staticRenderFns } from "./MatchSuspensionReportList.vue?vue&type=template&id=094fd7b8&"
import script from "./MatchSuspensionReportList.vue?vue&type=script&lang=js&"
export * from "./MatchSuspensionReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports